import { ColorShade } from "@/styles/nawy-theme/types";

// --- Utility function to create rgba from primitive with opacity
export const withOpacity = (
  color: string | undefined,
  opacity: number
): string => {
  if (!color) {
    return "transparent";
  }
  const hex = color.replace("#", "");
  const r = parseInt(hex.substring(0, 2), 16);
  const g = parseInt(hex.substring(2, 4), 16);
  const b = parseInt(hex.substring(4, 6), 16);

  return `rgba(${r}, ${g}, ${b}, ${opacity})`;
};

// --- Helper function to safely get primitive color
export const getPrimitiveColor = (
  colorObj: ColorShade,
  shade: keyof ColorShade
): string => {
  const color = colorObj[shade];
  if (!color) {
    throw new Error(`Color shade ${shade} not found in primitive`);
  }
  return color;
};
